var _path, _path2, _line, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoods(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0011 5.42859L5.42969 12.3721V26.2592L19.0011 32.5714L32.5725 25.6279V12.3721L19.0011 5.42859Z",
    stroke: "white",
    strokeWidth: 1.35714
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 12.8313L19.0011 19.617L32.187 12.8313",
    stroke: "white",
    strokeWidth: 1.35714
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.0614,
    y1: 19,
    x2: 19.0614,
    y2: 32.5714,
    stroke: "white",
    strokeWidth: 1.35714
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5071 15.3577L11.9114 15.6826L12.5613 16.874L13.157 16.5491L12.5071 15.3577ZM25.667 9.72544C25.996 9.54598 26.1172 9.1338 25.9378 8.80479C25.7583 8.47579 25.3461 8.35455 25.0171 8.53401L25.667 9.72544ZM13.157 16.5491L25.667 9.72544L25.0171 8.53401L12.5071 15.3577L13.157 16.5491Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2991 22.0848L9.13039 18.9999L9.13039 17.7661L15.2991 20.8509L15.2991 22.0848Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoods);
export default __webpack_public_path__ + "static/media/Goods.6d215accd4686f3afea8864fe24ef7f8.svg";
export { ForwardRef as ReactComponent };